var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-copyright"},[_c('div',{staticClass:"text"},[_vm._v("Copyright © 2006-2020 永辉超市版权所有 备案号：闽ICP备05003392号-1")])])}]

export { render, staticRenderFns }